/**
 * Created by shobhitjain on 27/12/19.
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * Expects Object of Header with Name key
 * @param data
 * @returns {*}
 * @constructor
 */
const TableHeader = ({ data }) => {
  return (
    <thead>
      <tr>
        {data.map((header) => {
          if (header) {
            return <th>{header.name}</th>;
          }

          return null;
        })}
      </tr>
    </thead>
  );
};
/**
 * Proptypes
 * @type {{data: shim}}
 */
TableHeader.propTypes = {
  data: PropTypes.array.isRequired
};

export default TableHeader;

/**
 * Expects Object of Header with Name key (without thead tag)
 * @param data
 * @returns {*}
 * @constructor
 */
export const TableHeaderWithoutHead = ({ data }) => {
  return (
    <tr>
      {data.map((header) => (
        <th>{header.name}</th>
      ))}
    </tr>
  );
};
/**
 * Proptypes
 * @type {{data: shim}}
 */
TableHeaderWithoutHead.propTypes = {
  data: PropTypes.array.isRequired
};

/**
 * Expects Object of Header with Name key (without thead tag)
 * @param data
 * @returns {*}
 * @constructor
 */
export const TableSubheaderWithoutHead = ({ data }) => {
  return (
    <tr>
      {data.map((header) => {
        // if column header is an array
        if (Array.isArray(header)) {
          if (header.length > 0) {
            const subHeaderItems = header.map((subHeaderItem) => {
              return <p>{subHeaderItem.name}</p>;
            });

            return <th>{subHeaderItems}</th>;
          } else {
            return <th></th>;
          }
        }

        // if column header is an object
        if (header) {
          return <th>{header.name}</th>;
        }

        // else, return empty th tag
        return <th></th>;
      })}
    </tr>
  );
};
/**
 * Proptypes
 * @type {{data: shim}}
 */
TableSubheaderWithoutHead.propTypes = {
  data: PropTypes.array.isRequired
};

/**
 * C2CTableHeader
 * @type {({name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string}|{name: string, key: string})[]}
 */
export const C2CTableHeader = [
  {
    name: 'Customer ID',
    key: 'primaryPartyKey'
  },
  {
    name: 'Linked Customer Name',
    key: 'partyName'
  },
  {
    name: 'Linked Customer ID',
    key: 'linkedPartyKey'
  },
  {
    name: 'Linked Relationship Description',
    key: 'relationDescription'
  },
  {
    name: 'Shareholder Percentage',
    key: 'shareholderPercentage'
  },
  {
    name: 'Business Segment',
    key: 'segment'
  },
  {
    name: 'Type of Business/Nature of Business',
    key: 'occupation'
  },
  {
    name: 'Risk Rating',
    key: 'riskRating'
  },
  {
    name: 'Date of Birth/ Date of Incorporation',
    key: 'dobOrIncorporationDate'
  },
  {
    name: 'Nationality / Country of Incorporation',
    key: 'nationality'
  },
  {
    name: 'Alert Raised for TM',
    key: 'tm_alert_count'
  },
  {
    name: 'Alert Raised for NS',
    key: 'ns_alert_count'
  }
];
